import { FormikContext } from 'formik';
import { IProjectData } from '../action/project';
import { IPagedQuery } from './paginate';
import * as actionTypeProfile from '../../models/action/profile';
import { IAdd } from './add-activity';

export interface IProjectActivityAddProps {
    isUpdate: any;
    coursePageClassId: string;
    coursePageActivityId: string;
    isWeekly: boolean;
    currentTab: string;
    isGroupProject: boolean;
    fileInputKey: string;
    dateFormat: string;
    termType: string;
    triggerModal?: () => void;
}

export interface IFormikProps extends IProjectActivityAddProps {
    formik: FormikContext<IOuterProps>;
}

export interface IOuterProps extends IProjectData {
    formik: any;
}

export interface IPageProps {
    history?: any;
    location?: any;
    match?: any;
    dispatch?: any;
}

export interface IGroupFormikProps extends IProjectGroupTabProps {
    formik: FormikContext<IOuterProps>;
    dispatch: any;
}

export interface IProjectGroupTabProps extends IAdd {
    lastCreatedGroupId?: string;
    coursePageClassId?: string;
    coursePageActivityId?: string;
    currentTab?: string;
    projectData?: IProjectData;
    triggerModal?: () => void;
    sendGroupsToParent?: (groups: any) => void;
    sendProjectTypeToParent?: (value: boolean) => void;
    isUpdate?: any;
}

export interface ISelectGroupsProps {
    isUpdate?: any;
    coursePageActivityId: string;
    currentTab: string;
    triggerModal?: () => void;
}

export interface IAddModalProps extends IPageProps {
    results?: Array<IStudentItem>;
    coursePageClassId?: string;
    filters?: IFilterStudent;
    studentList?: Array<any>;
    userPreferences?: Array<actionTypeProfile.IPreference>;
    disallowedGroupIds?: any;
    selectedGroupId?: string;
}

export interface IStudentItem {
    userId: string | null;
    hashedUserId: string | null;
    userName: string | null;
    firstName: string | null;
    lastName: string | null;
    userAvatar: string | null;
    trackingGuid: string | null;
}

export interface IFilterStudent extends IPagedQuery {
    searchKey: string | null;
    courseId: string | null;
    classId: string | null;
    userType: number | null;
    groupId: string | null;
    skip: number;
    totalCount: number | null;
    disallowedGroupIds: Array<string>;
    selectedGroupId: string;
}

export const StudentAddModalFilterValues: IFilterStudent = {
    orderBy: '',
    searchKey: '',
    classId: '',
    courseId: '',
    userType: 0,
    groupId: null,
    totalCount: null,
    query: null,
    page: 1,
    total: -1,
    skip: 0,
    take: 10,
    disallowedGroupIds: [],
    selectedGroupId: ''
};
